import React from 'react';
import FormControl from '../../components/FormControl';
import { ErrorToastComponent as ErrorToast } from '../../components/Toasts';
import { postData } from '../../helper';
import { BasicCard } from '../../components/Card';

class AddShopPage extends React.Component {
    constructor(props) {
        super();
        this.submitHandler = this.submitHandler.bind(this);
        this.pageContent = this.pageContent.bind(this);
        const self = this;
        this.state = {
            err_message: null,
            form: {
                onSubmit: self.submitHandler
            },
            fields: { 
                site_name: {
                    label: 'Shop Name',
                    type: 'text',
                    placeholder: 'A shop name defines the items being sold, make sure it is unique.',
                    value: '',
                    required: true,
                    onChange: self.onChangeHandler
                },
                description: {
                    label: 'Description',
                    type: 'text',
                    placeholder: 'Brief information about your shop',
                    value: '',
                    required: true,
                    onChange: self.onChangeHandler
                },
                type: {
                    type: 'select',
                    placeholder: 'Category',
                    value: 'internet',
                    required: true,
                    options: {
                        food: 'Food/Drinks',
                        clothing: 'Clothing',
                        electronics: 'Electronics',
                        multiple: 'Multiple Categories',
                        other: 'Other'
                    },
                    onChange: self.onChangeHandler
                },
                create_button: {
                    type: 'button',
                    label: 'Add Shop',
                    btn_type: 'submit'
                }
            }
        };
    }

    componentDidMount() {
        try {
            
        } catch(err) {
            throw new Error(err.message);
        }
    }

    onChangeHandler = (e) => {
        try {
            const fields = this.state.fields;
            fields[e.target.name].value = e.target.value;
            this.setState({fields: fields});
        } catch(err) {
            throw new Error(err.message);
        }
    }

    async submitHandler(payload) {
        try {
            const response = await postData('/sites', payload);
            if(response.error && response.error.message) {
                this.setState({err_message: response.error.message});
            } else {
                window.location.href = `/shop?screen=list`;
                return;
            }

        } catch(err) {
            return new Error(err.message);
        }
    }

    pageContent() {
        try {
            return (
                <>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className="card o-hidden border-0">
                                    <div className="card-body p-0">
                                        <div className="p-5">
                                            <FormControl fields={this.state.fields} config={this.state.form}/>
                                            <ErrorToast message={this.state.err_message}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        } catch(err) {
            throw new Error(err.message);
        }
    }

    render() {
        return (
            <>
                <div class='container'>
                    <BasicCard title='New Shop' content={this.pageContent(this.props)}/>
                </div>
            </>
        );
    }
}

export default AddShopPage;